import { useShowContext } from 'framework/show';
import { Box, Typography } from '@mui/material';
import { WeeklyChartDataType } from '../types';

const CountElement = ({ text, color }: { text: string; color: string }) => (
  <Typography component="span" color={color}>
    {text}
  </Typography>
);

const isProjectKey = (key: string): boolean => !['name', 'pyloadData'].includes(key);

const getWeeklyLoad = (week: WeeklyChartDataType): number =>
  Object.entries(week)
    .filter(([key]) => isProjectKey(key))
    .reduce((sum, [, value]) => sum + Number(value ?? 0), 0);

const hasWeekData = (week: WeeklyChartDataType): boolean => Object.keys(week).some(isProjectKey);

const formatWeekText = (count: number) => `${count} week${count !== 1 ? 's' : ''}`;

const AdditionalReportedTimeSection = () => {
  const { data } = useShowContext<{ weeklyChartData: WeeklyChartDataType[] }>();
  const { weeklyChartData } = data.getData();

  const metricWeeks = weeklyChartData.filter(hasWeekData);
  const loads = metricWeeks.map(getWeeklyLoad);

  const averageLoad = (loads.reduce((sum, val) => sum + val, 0) / loads.length).toFixed(1);
  const underReportedCount = loads.filter(load => load < 100).length;
  const under90Count = loads.filter(load => load < 90).length;
  const over120Count = loads.filter(load => load >= 120).length;

  return (
    <Box>
      <Typography variant="body1">
        Average load: <CountElement text={`${averageLoad}%`} color="warning" />
      </Typography>

      <Typography variant="body1">
        Under-reported on{' '}
        <CountElement
          text={`${underReportedCount} of ${metricWeeks.length} weeks`}
          color="var(--mui-palette-error-main)"
        />
      </Typography>

      <Typography variant="body1">
        Under 90%: <CountElement text={formatWeekText(under90Count)} color="error" />
      </Typography>

      <Typography variant="body1">
        Over 120%: <CountElement text={formatWeekText(over120Count)} color="success" />
      </Typography>
    </Box>
  );
};

export default AdditionalReportedTimeSection;
